import React, {Component} from "react"
import PropTypes from "prop-types"

import { countryDialCodes } from "./countryDialCodes"

const defaultDialCode = "+44"

export class PhoneNumber extends Component {
  constructor(props) {
    super(props)
    this.handlePhoneLineChange = this.handlePhoneLineChange.bind(this)
    this.handleDialCodeChange = this.handleDialCodeChange.bind(this)
    this.state = {
      dialCode: defaultDialCode,
      phoneLine: "",
    }
  }

  handlePhoneLineChange(event) {
    this.setState({
      phoneLine: event.target.value
    })
    let phoneNumber = `${this.state.dialCode}${event.target.value}`
    this.props.onChange(phoneNumber)
  }

  handleDialCodeChange(event) {
    this.setState({
      dialCode: event.target.value
    })
    let phoneNumber = `${event.target.value}${this.state.phoneLine}`
    this.props.onChange(phoneNumber)
  }

  render() {
    return (
      <div className="phone-field">
        <select
          className="phone-field__dialcode field__select"
          name="dial_code"
          onChange={this.handleDialCodeChange}
        >
          {countryDialCodes.map(dialCode => (
            <option key={dialCode} value={dialCode} selected={dialCode === defaultDialCode}>
              {dialCode}
            </option>
          ))}
        </select>
        <input
          className="phone-field__number field__input"
          id="phone_line_number"
          key="phone_line_number"
          name="phone_line_number"
          required
          onChange={this.handlePhoneLineChange}
          type="tel"
        />
      </div>
    )
  }
}

PhoneNumber.propTypes = {
  onChange: PropTypes.func
}

export default PhoneNumber
